import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { INTEGRATION_LIBRARY_EVENT } from '../const/integration/INTEGRATION_LIBRARY_EVENT';

export const useIntegrationLibrary = () => {
    const history = useHistory();

    useEffect(() => {
        window.parent.postMessage({
            type: INTEGRATION_LIBRARY_EVENT.LOADED,
        }, '*');
    }, []);

    useEffect(() => {
        const messageHandler = ({ data }) => {
            if (typeof data !== 'object'){
                return;
            }
            const { type, payload } = data;
            if (!type) {
                return;
            }
            if ([INTEGRATION_LIBRARY_EVENT.REDIRECT].includes(type)) {
                const { url } = payload;
                history.push(url);
            }
        };
        window.addEventListener('message', messageHandler);
        return () => window.removeEventListener('message', messageHandler);
    }, [history]);
};
